<template>
  <div class="ma-4 app">
    <div class="text-h4 mb-2">Cadastro de Ramal</div>
    <v-tabs v-model="tabs" background-color="background">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <AbaRamalPjsip edicao="false" />
      </v-tab-item>
      <v-tab-item>
        <AbaRamalVirtual edicao="false" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AbaRamalPjsip from '../_components/AbaRamalPjsip'
import AbaRamalVirtual from '../_components/AbaRamalVirtual'

export default {
  name: 'CadastroRamais',
  components: { AbaRamalVirtual, AbaRamalPjsip },
  data: () => ({
    tipos: 2,
    tab: null,
    tabs: 2,
    tipo: ['PJSIP', 'Virtual'],
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
